import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';

import { dropdownReposeModel, multi_level_approval_RequestModel, multi_level_approval_ResponseModel, MultiLevelApprovalResponseModel, organizationMarginReposeModel, organizationMarginRequestModel, organizationReposeModel, organizationRequestModel, OrganizationSettingsDetailsRequestModel, OrganizationSettingsResponseModel, timeZoneReposeModel } from '../../organization/models/organization';
//import { organizationMarginReposeModel, organizationMarginRequestModel } from '../models/organization-margin';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';
import { customDataModel } from 'src/app/shared/models/custom-fields';

@Injectable({
  providedIn: 'root'
})
export class OrganizationSettingsService {
  public orgSettingsSubject = new BehaviorSubject<any>(null);
  orgSettings$ = this.orgSettingsSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    private router: Router,
  ) { }


  storeOrgSetting(orgSetting: any) {
    localStorage.setItem('org-setting', JSON.stringify(orgSetting));
  }

  getOrgSetting(): Observable<organizationReposeModel> {
    return this.httpClient.get<organizationReposeModel>(apiEndpoints.organization).pipe(
      map((response: organizationReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  Orgddl(): Observable<dropdownReposeModel> {
    return this.httpClient.get<dropdownReposeModel>(apiEndpoints.organizer_console_ddl).pipe(
      map((response: dropdownReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateOrgSetting(updatedClient: organizationRequestModel): Observable<organizationReposeModel> {
    return this.httpClient.put<organizationReposeModel>(apiEndpoints.organization, updatedClient).pipe(
      map((response: organizationReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  updateLiftMargin(update: organizationMarginRequestModel): Observable<organizationMarginReposeModel> {
    return this.httpClient.put<organizationMarginReposeModel>(apiEndpoints.organizer_margin, update).pipe(
      map((response: organizationMarginReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createLiftMargin(addMargin: organizationMarginRequestModel): Observable<organizationMarginReposeModel> {
    return this.httpClient.post<organizationMarginReposeModel>(apiEndpoints.organizer_margin, addMargin).pipe(
      map((response: organizationMarginReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getCustomFiled(pagination: any): Observable<customDataModel> {
    return this.httpClient.get<customDataModel>(apiEndpoints.get_custom_fields + `?usage_id=${pagination.usage}&page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: customDataModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  // getUpLiftMargin(pagination): Observable<organizationMarginReposeModel> {
  //   return this.httpClient.get<organizationMarginReposeModel>(apiEndpoints.organizer_margin + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
  //     map((response: organizationMarginReposeModel) =>
  //       response
  //     ),
  //     catchError((error: HttpErrorResponse) => {
  //       throw new Error('Something went wrong. Please try again later.');
  //     })
  //   );
  // }

  // deleteUpLiftMargin(pagination): Observable<organizationMarginReposeModel> {
  //   return this.httpClient.get<organizationMarginReposeModel>(apiEndpoints.organizer_margin + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
  //     map((response: organizationMarginReposeModel) =>
  //       response
  //     ),
  //     catchError((error: HttpErrorResponse) => {
  //       throw new Error('Something went wrong. Please try again later.');
  //     })
  //   );
  // }

  // deleteClientNotes(uplift_margin_id,data):Observable<any>{
  //   return this.httpClient.patch<any>(apiEndpoints.organizer_margin + uplift_margin_id + `/`,data).pipe(
  //     map((response: any) =>
  //       response
  //     ),
  //     catchError((error: HttpErrorResponse) => {
  //       throw new Error('Something went wrong. Please try again later.');
  //     })
  //   );
  // }

  multiLevelApprovalList(page: number, limit: number): Observable<multi_level_approval_ResponseModel> {
    return this.httpClient.get<multi_level_approval_ResponseModel>(apiEndpoints.multi_approval_level + `?page=${page}&limit=${limit}`).pipe(
      map((response: multi_level_approval_ResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  createMultiLevelApproval(request: multi_level_approval_RequestModel): Observable<MultiLevelApprovalResponseModel> {
    return this.httpClient.post<MultiLevelApprovalResponseModel>(apiEndpoints.multi_approval_level, request).pipe(
      map((response: MultiLevelApprovalResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getmultiLevelApprovalDetails(staff_id: any): Observable<MultiLevelApprovalResponseModel> {
    return this.httpClient.get<MultiLevelApprovalResponseModel>(apiEndpoints.user_multi_approval_level + `?staff_id=${staff_id}`).pipe(
      map((response: MultiLevelApprovalResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getOrganizationSettingsDetails(): Observable<OrganizationSettingsResponseModel> {
    return this.httpClient.get<OrganizationSettingsResponseModel>(apiEndpoints.organization_detail).pipe(
      map((response: OrganizationSettingsResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.')
      })
    );
  }

  updateOrganizationSettingsDetails(request: OrganizationSettingsDetailsRequestModel): Observable<OrganizationSettingsResponseModel> {
    return this.httpClient.put<OrganizationSettingsResponseModel>(apiEndpoints.organization_detail, request).pipe(
      map((response: OrganizationSettingsResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.')
      })
    )
  }
}
